<template>
  <section>
    <Title :title-name="title.ServiceOptionRouting.titleName" :title-link="title.ServiceOptionRouting.titleLink" />
    <div class="select_service">
      <div class="container" style="padding: 14pt">
        <p>Dear {{ pax.title }}&nbsp;{{ pax.first_name }}&nbsp;{{ pax.last_name }},</p>
        You have chosen for re-routing on a future flight.
      </div>
      <div class="block-item">
        <div class="container">
          <h2 class="title" style="font-size: 16pt; width: 100%; margin: 0">Re-routing, on a future flight</h2>
        </div>
      </div>
      <div class="container" style="padding: 14pt">
        <p>Click on below button to get your personal voucher code which you can use as payment for your new booking.</p>
        <div class="text-right">
          <a href="" class="btnOrange" style="color: #000">GET VOUCHER</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/SelectService.scss'
import { replaceStr } from '@/utils/helper'
import Title from '@/components/Title/index'

export default {
  name: 'ServiceOptionRouting',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  methods: {
    replaceStr
  }
}
</script>
